import { render } from "./Account.vue?vue&type=template&id=8316a4c6&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=8316a4c6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8316a4c6"

export default script